import keycloakService from '../../keycloak_service';

import { putRequestToKeycloak } from '../api_utils';

const changeUserStatus = (userId = null, enabled = false) => {
  const keycloakHeader = keycloakService.getAuthHeader();
  const fetchOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakHeader,
    },
    body: JSON.stringify({
      enabled,
    })
  };

  const realm = keycloakService.keycloak.realm || null;
  const keycloakEndpoint = `admin/realms/${realm}/users/${userId}`;

  return putRequestToKeycloak(keycloakEndpoint, fetchOptions);
};

export default changeUserStatus;
